// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatMenu-moduleitem__ISSUL";
var _2 = "GretaAIChatChatMenu-moduleitemIcon__X6e6W IconNG-moduleIcon__AbXiV";
var _3 = "GretaAIChatChatMenu-moduleitemLabel__GgM9m";
var _4 = "GretaAIChatChatMenu-modulemenu__zfak_";
export { _1 as "item", _2 as "itemIcon", _3 as "itemLabel", _4 as "menu" }
